import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface Notification {
    id: string;
    message: string;
    type?: "info" | "success" | "error";
    autoDismiss?: boolean;
}

interface NotificationsState {
    data: Notification[];
}

const initialState: NotificationsState = {
    data: [],
};
const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        resetNotifications: () => initialState,
        setNotifications: (state, action: PayloadAction<Notification[]>) => {
            state.data = action.payload;
        },
        updateNotifications: (state, action: PayloadAction<Notification>) => {
            const exists = state.data.some(n => n.message === action.payload.message);
            if (!exists) {
                state.data.push(action.payload);
            }
        },
        removeNotification: (state, action: PayloadAction<Notification>) => {
            state.data = state.data.filter((n) => n.id !== action.payload.id);
        },
    },
});

export const { resetNotifications, setNotifications, updateNotifications, removeNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;